




















import Vue from 'vue';
import { BACKEND_URL } from "../constants";
import FieldInput from "@/components/FieldInput.vue";

const FIELDS_URL = BACKEND_URL + "/struct"; // ?type=NAME

export default Vue.extend({

    components: {
        FieldInput,
    },

    props: {
        item: Object,
        context: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            fields: [] as any[],
        };
    },

    mounted() {
        this.loadFieldTypes();
    },

    watch: {
        item() {
            this.loadFieldTypes();
        },
    },

    methods: {

        cancelEdit() {
            this.$store.dispatch('editItem', { id: this.item.id, editing: false });
        },

        submit() {
            const props = {} as Record<string, string>;
            this.fields.forEach( (f: any) => {
                const fieldName = this.fieldName(f);
                const el = document.getElementById(fieldName) as any;
                if (el) {
                    const value = el.type === 'checkbox' ? (el.checked ? 1 : 0) : (el.files ? el.files[0] : el.value);
                    const name = f.type === 'file' ? fieldName : `prop_${f.name}`;
                    props[name] = value;
                }
            });
            this.$store.dispatch('updateItem', { id: this.item.id, props });
        },

        fieldName(f: any) {
            if (f.type === 'file') {
                switch (f.name) {
                case 'image':
                    return 'imagefile'; // show fileupload, then map that to prop in backend
                case 'thumbnail':
                    return 'thumbnail'; // show fileupload, then map that to prop in backend
                case 'name':
                    return 'file'; // show fileupload, then map that to prop in backend
                }
            }
            return f.name;
        },

        fieldDisplayName(s: string) {
            if (s === 'name')
                return 'title';
            return s;
        },

        loadFieldTypes() {
            if (this.item) {
                const url = FIELDS_URL + "?type=" + encodeURIComponent(this.item.itemType);
                Vue.axios.get(url).then((response: { data: any }) => {
                    this.fields = response.data.fields;
                });
            }
        },
    },

});
